import { alphabeticalCompare } from '@cims-online/shared'
import { HelpMessage } from 'utils/constants'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { ConcreteCoreMeasurement } from '../types'

export function useColumns(): CIMSColumn<ConcreteCoreMeasurement>[] {
  const help = HelpMessage.Concrete.ConcreteTestSetTracker.CoresTable
  return [
    {
      title: 'Core ID',
      help: help.CoreID,
      render: coreId,
      width: 175,
      sort: {
        with: 'callback',
        onCompare: (a, b) => alphabeticalCompare(coreId(a), coreId(b)),
        default: 'ascend',
      },
    },
    {
      title: 'Core Location',
      help: help.CoreLocation,
      width: 145,
      render: ({ station, offset }) =>
        station && offset ? `${station} ${offset}` : station ?? offset,
    },
    {
      title: 'Alignment',
      help: help.Alignment,
      width: 120,
      render: 'alignment',
    },
    {
      title: 'Req. Thickness',
      width: 150,
      help: help.ReqThickness,
      render: 'requiredThickness',
    },
    {
      title: 'Avg. Thickness',
      width: 150,
      help: help.AvgThickness,
      render: 'requiredThickness',
    },
    {
      title: 'Status',
      width: 95,
      help: help.Status,
      render: 'status',
    },
    {
      title: 'Break Strength',
      width: 150,
      help: HelpMessage.Concrete.ConcreteTestSetTracker.BreakData.Core.Strength,
      render: ({ concreteCoreBreakData }) => concreteCoreBreakData?.strength,
    },
    {
      title: 'Notes',
      help: help.Notes,
      width: 273,
      render: 'notes',
    },
  ]
}

function coreId({ placementId, measurementId }: ConcreteCoreMeasurement) {
  return `${placementId}-${measurementId}`
}
